import { render, staticRenderFns } from "./WizardTso.vue?vue&type=template&id=f26deb38&"
import script from "./WizardTso.vue?vue&type=script&lang=js&"
export * from "./WizardTso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports